import { STATE } from './state'
import { POI } from '@/interfaces/poi.interface'

export default {
  selectedPoiGeojson: (state: STATE, _getters, rootState) => {
    if (!rootState.selectedPoi) return null
    return state.poisForSelectedLevel.find(
      (poi) => poi.properties.guid === rootState.selectedPoi.guid
    )
  },
  selectedLevelVisiblePois(state: STATE): POI[] {
    const arrayOfVisiblePois = []
    for (const poiCategory of state.poiCategoriesForSelectedLevel) {
      for (const type of poiCategory.types) {
        if (type.visible) {
          // @ts-ignore
          arrayOfVisiblePois.push(type)
        }
      }
    }
    const visiblePois = state.poisForSelectedLevel?.filter((item) => {
      for (const type of arrayOfVisiblePois) {
        // @ts-ignore
        if (item.properties.typeId === type.id) return true
      }
      return false
    })
    return visiblePois
  }
}
